import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import UseGeneral from "../../hooks/useGeneral";
import { Loader } from "rsuite";
import "./style.css";

function Gallery() {
  const { language } = UseGeneral();
  const [pageLoading, setPageLoading] = useState(false);
  const [favs, setFavs] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const getUserFavs = () => {
    setPageLoading(true);
    Axios({
      url: BASE_URL + "gallery/get_all_for_user",
      method: "GET",
    })
      .then((res) => {
        setFavs(res.result);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to load favorites");
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  useEffect(() => {
    getUserFavs();
  }, []);

  const handleItemClick = (item, index) => {
    setActiveItem(item);
    setCurrentIndex(index);
    setIsClosing(false);
    document.body.classList.add("no-scroll");
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setActiveItem(null);
      setIsClosing(false);
      document.body.classList.remove("no-scroll");
    }, 500); // Duration matches the CSS animation duration
  };

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % favs.length;
    setActiveItem(favs[newIndex]);
    setCurrentIndex(newIndex);
  };

  const handlePrev = () => {
    const newIndex = (currentIndex - 1 + favs.length) % favs.length;
    setActiveItem(favs[newIndex]);
    setCurrentIndex(newIndex);
  };

  return (
    <div className="galleryContainer">
      {pageLoading ? (
        <Loader />
      ) : !favs ? (
        <Loader />
      ) : favs.length ? (
        <div className="gallery">
          {favs.map((item, index) => (
            <div
              key={item.id}
              className="gallery-item"
              onClick={() => handleItemClick(item, index)}
            >
              {item.type === "image" ? (
                <img src={item.file} alt={item.title_en} className="gallery-media" />
              ) : (
                <video autoPlay loop muted className="gallery-media">
                  <source src={item.file} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              <div className="gallery-description">
                <h3>{language === "ar" ? item.title_ar : item.title_en}</h3>
                <p>{language === "ar" ? item.description_ar : item.description_en}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No Images found</p>
      )}

      {activeItem && (
        <div className={`modal ${isClosing ? "fade-out" : "fade-in"}`} onClick={handleClose}>
          <div className={`modal-content ${isClosing ? "zoom-out" : "zoom-in"}`} onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={handleClose}>&times;</span>
            <button className="carousel-button prev" onClick={handlePrev}>&#10095;</button>
            {activeItem.type === "image" ? (
              <img src={activeItem.file} alt={activeItem.title_en} className="modal-media" />
            ) : (
              <video autoPlay loop muted controls className="modal-media">
                <source src={activeItem.file} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            <button className="carousel-button next" onClick={handleNext}>&#10094; </button>
            <div className="modal-description">
              <h3>{language === "ar" ? activeItem.title_ar : activeItem.title_en}</h3>
              <p>{language === "ar" ? activeItem.description_ar : activeItem.description_en}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
